
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CodeBlock',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Code Block'
    },
    code: {
      type: String,
      required: false,
      default: `move_to_position(x, y)`
    },
    definition: {
      type: String,
      required: false,
      default: `def move_to_position(x, y):
    pass`
    }
  },
  data(): {} {
    return {};
  },
  methods: {
    onDragStart(e: DragEvent) {
      console.log('drag starting');
      e.dataTransfer?.setData('codeBody', this.$props.code);
      e.dataTransfer?.setData('codeDef', this.$props.definition);
    }
  }
});
